export enum CardDelivery {
  EMPLOYER_ADDRESS = "EMPLOYER_ADDRESS",
  EMPLOYEE_ADDRESS = "EMPLOYEE_ADDRESS"
}
